import { makeStyles } from 'tss-react/mui';

export default makeStyles<{ color: 'light' | 'dark' }>({ name: 'ActionButton' })((_theme, { color }) => ({
    button: {
        padding: '16px 40px',
        borderRadius: 80,
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        background: color === 'dark' ? '#232323 !important' : color === 'light' ? '#F8F8F8 !important' : undefined,
        color: color === 'dark' ? '#FFFFFF !important' : color === 'light' ? '#232323 !important' : undefined,
        whiteSpace: 'nowrap'
    }
}));
